import React from 'react';
import { Box, Container, Typography, Paper, Avatar, Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { Edit } from '@mui/icons-material';

const ProfilePage: React.FC = () => {
  const { user } = useAuth();

  return (
    <Box sx={{ minHeight: '100vh', py: 4, background: '#fafbfc' }}>
      <Container maxWidth="lg">
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Profile
        </Typography>
        
        <Paper sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
            <Avatar
              sx={{
                width: 80,
                height: 80,
                bgcolor: 'primary.main',
                fontSize: '2rem',
                mr: 3,
              }}
            >
              {user?.firstName?.[0]}{user?.lastName?.[0]}
            </Avatar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h5" fontWeight="bold">
                {user?.firstName} {user?.lastName}
              </Typography>
              <Typography color="text.secondary">
                {user?.email}
              </Typography>
            </Box>
            <Button variant="outlined" startIcon={<Edit />}>
              Edit Profile
            </Button>
          </Box>
          
          <Typography>Profile details coming soon...</Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default ProfilePage;